import type { IPositions } from '../../../domain/positions';

/**
 * The PositionsListEvent is dispatched by the PositionsList when the selected position changes.
 *
 * It stands in for the SelectListEvent the SelectList raises, which the PositionsList keeps to itself: a listener above the list hears about positions, not about list items, and lists nested further down cannot be mistaken for this one.
 */
export default class PositionsListEvent extends Event {
	/**
	 * The static POSITION_SELECTION_CHANGED type is dispatched when a position is selected or de-selected.
	 *
	 * Example: addEventListener(PositionsListEvent.POSITION_SELECTION_CHANGED, (event: PositionsListEvent) => {});
	 */
	public static POSITION_SELECTION_CHANGED = 'PositionsListEvent.positionSelectionChanged';

	/** The position that is selected, or null when none is: a de-selection leaves nothing selected. */
	public selectedPosition: IPositions | null;

	public constructor(selectedPosition: IPositions | null = null) {
		super(PositionsListEvent.POSITION_SELECTION_CHANGED, { bubbles: true });
		this.selectedPosition = selectedPosition;
	}
}
